import { Box, Divider } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { StyledGridBorder, StyledGridContainer } from "../dashboard/style";
import Grid from "@mui/material/Grid2";
import { ListGroups } from "../../components/list-group/ListGroups";
import CustomHeader from "../../components/naming-header/CustomHeader";
import {
  StyledBox,
  StyledBoxInnerHeader,
  StyledBoxPad,
  StyledEmptyState,
  StyledEmptyStateImage,
  StyledEmptyStateText,
  StyledEmptyStateTitle,
  StyledEmptyStateVisual,
  StyledGridLocker,
  StyledTypography,
  StyledTypographyMem,
  StyledTypographyTitle,
} from "./style";
import groupIcon from "../../assets/images/demo-group-icon.png";
import dollarIcon from "../../assets/images/dollar.png";
import markGroupIcon from "../../assets/images/mask-group.png";
import shoppingBag from "../../assets/images/shopping-bag.png";
import { GroupOverviewBox } from "../../components/list-group/style";
import theme from "../../theme";
import CustomButton from "../../components/common/button/CustomButton";
import Share from "../../assets/Icons/Share";
import CustomLocker from "../../components/list-item/ListItem";
// import { arr } from "./constant";
import BlockLock from "../../components/block-lock/BlockLock";
import ManualSplit from "../../components/modals/manual-split-calculation/ManualSplit";
import CreateGroup from "../../components/modals/create-group/CreateGroup";
import GroupCartGuidelines from "../../components/modals/group-cart-guidelines/GroupCartGuidelines";
import { useDispatch, useSelector } from "react-redux";
import {
  GROUP_CART_LIST,
  GROUP_CART_SINGLE,
} from "../../actions/group-cart-actions";
import UnassignedItems from "../../components/list-item/UnassignedItems";
import InviteMembers from "../../components/modals/invite-members/InviteMembers ";
import { formatName, formatToLongDate } from "../../utils/common"; //Rishabh
import Loader from "../../components/common/loader/Loader";

const GroupCart = () => {
  const [openProfileSuccess, setOpenProfileSuccess] = useState(false);
  const [openGroupCartDetails, setOpenGroupCartDetails] = useState(false);

  const [openGuidelinesDetails, setOpenProductDetails] = React.useState(false);
  const handleOpenProductDetails = () => setOpenProductDetails(true);
  const handleCloseProductDetails = () => setOpenProductDetails(false);
  const handleOpenProfileSuccess = () => setOpenProfileSuccess(false);
  const handleCloseProfileSuccess = () => setOpenProfileSuccess(false);
  const handleOpenGroupCartDetails = () => setOpenGroupCartDetails(true);
  const [openUnassigned, setOpenUnassigned] = useState(false);
  const [openInviteMembers, setOpenInviteMembers] = useState(false);

  const handleOpenInviteMembers = () => setOpenInviteMembers(true);
  const handleCloseInviteMembers = () => setOpenInviteMembers(false);

  const handleCloseGroupCartDetails = () => {
    setOpenGroupCartDetails(false);
  };
  // useEffect(() => {
  //   handleOpenProfileSuccess();
  // }, []);
  const dispatch = useDispatch();

  const groupCartDetails = useCallback(
    (values) => {
      dispatch({ type: GROUP_CART_LIST, payload: { page: 1, limit: 10 } });
    },
    [dispatch]
  );
  const groupCartData = useSelector((state) => state?.groupCartData?.groupCart);
  const isLoading = useSelector((state) => state?.groupCartData?.isLoading);
  const hasFetchedGroupCartList = useSelector(
    (state) => state?.groupCartData?.hasFetchedGroupCartList
  );
  /** Full-page loader: initial mount, list in flight, or list loading with no cached rows (not single-cart fetch). */
  const showListLoader =
    !hasFetchedGroupCartList || (isLoading && !groupCartData?.length);
  useEffect(() => {
    if (groupCartData?.length > 0) {
      dispatch({
        type: GROUP_CART_SINGLE,
        payload: { id: groupCartData[0].id }, // default first one
      });
    }
  }, [groupCartData, dispatch]);
  const handleCartClick = (cartId) => {
    dispatch({ type: GROUP_CART_SINGLE, payload: { id: cartId } });
  };
  useEffect(() => {
    groupCartDetails();
  }, [groupCartDetails]);
  const singleCart = useSelector((state) => state?.groupCartData?.singleCart);
  return (
    <>
    {showListLoader ? (
      <Loader />
    ) : (
      <>
       <StyledBox>
      <CustomHeader
        title="Group Cart "
        label="Create Group Cart"
        onClick={handleOpenGroupCartDetails}
      />
      {groupCartData?.length > 0 ? (
        <StyledGridContainer container spacing={0}>
        <StyledGridBorder size={{ lg: 4.5, md: 12, xs: 12 }}>
          <StyledTypography>List of Groups</StyledTypography>
          <Divider />

          {/* use Static Data */}
          {/* {groupCartData?.map((cart) => (
            <StyledBoxPad key={cart.id}>
              <ListGroups
                icon1={groupIcon}
                title={cart.cart_name}
                text={`${cart.cart_members?.length ?? 0} Members added`}
                chiptitle={`${cart.itemMappings?.length ?? 0} Items Added`}
                icon2={dollarIcon}
                value="1500 USD"
                day={`${cart.cart_timeline} Days Due`}
              />
            </StyledBoxPad>
          ))} */}

          {groupCartData?.map((cart, ind) => (
            <StyledBoxPad key={cart.id} onClick={() => handleCartClick(cart.id)}>
              <ListGroups
                icon1={groupIcon}
                title={cart.cart_name}
                text={`${cart.cart_members?.length ?? 0} Members added`}
                chiptitle={`${cart.itemMappings?.length ?? 0} Items Added`}
                icon2={dollarIcon}
                value="1500 USD"
                day={`${cart.cart_timeline} Days Due`}
                isActive={singleCart?.id === cart.id}
              />
            </StyledBoxPad>
          ))}
        </StyledGridBorder>
        <Grid size={{ lg: 7.5, md: 12, xs: 12 }}>
          <StyledBoxInnerHeader>
            <GroupOverviewBox>
              <img src={markGroupIcon} alt="markGroupIcon" loading="lazy" />
              <Box>
                <StyledTypographyTitle>
                  {singleCart?.cart_name}
                </StyledTypographyTitle>
                <StyledTypographyMem>{`${singleCart.cart_members?.length ?? 0} `} Members</StyledTypographyMem>
              </Box>
            </GroupOverviewBox>
            <CustomButton
              fontSize={theme.typography.tiny.fontSize}
              startIcon={<Share width={20} height={20} />}
              btntype="danger"
              btnLabel="Share Link"
              isshare="true"
              onClick={handleOpenInviteMembers}
            />
          </StyledBoxInnerHeader>
          {/* use Static Data */}
          {/* <StyledGridLocker container spacing={2}>
            <Grid size={{ md: 6, sm: 6, xs: 12 }}>
              {arr?.map((item) => {
                return (
                  <CustomLocker
                    key={item.sender}
                    sendNumOrValue={item?.sender}
                    senderType={item?.senderType}
                    createdAt={item?.createdAt}
                    expDelivery={item?.expDelivery}
                    images={item?.images}
                  />
                );
              })}
            </Grid>
          </StyledGridLocker> */}
          <StyledGridLocker container spacing={2}>
            {singleCart?.itemMappings?.map((item,index) => {
              return (
                <Grid key={item?.item?.id} size={{ xxl: 6, xl: 12, lg: 12, md: 6, sm: 6, xs: 12 }}>
                  <CustomLocker
                    product={formatName(item?.item?.product_name)}
                    sendNumOrValue={formatName(item?.item?.order_type)}
                    createUser={item?.item?.create_by_user}
                    chip1Title={item?.item?.shelf_no}
                    chip2Title={formatName(item?.item?.order_type)} 
                    senderType={formatName(item?.item?.order_type)}
                    status={item?.item?.status}
                    createdAt={formatToLongDate(item?.createdAt)}
                    expDelivery={formatToLongDate(item?.item?.estimated_delivery)}
                    // images={item?.images}
                    itemId={item?.item?.id}
                    quantity={item?.item?.quantity}
                    //Rishabh
                    images={item?.images || []}
                  />
                </Grid>
              );
            })}

              <Grid size={{ xxl: 6, xl: 12, lg: 12, md: 6, sm: 6, xs: 12 }}>
                <BlockLock border="true" handleOpen={setOpenUnassigned} />
              </Grid>
            </StyledGridLocker>
          </Grid>
        </StyledGridContainer>
      ) : (
        <StyledEmptyState>
          <StyledEmptyStateVisual>
            <StyledEmptyStateImage
              src={shoppingBag}
              alt="Empty group cart"
              loading="lazy"
            />
          </StyledEmptyStateVisual>
          <StyledEmptyStateTitle>No group carts yet.</StyledEmptyStateTitle>
          <StyledEmptyStateText>
            Your group cart is empty. Use the Create Group Cart button above to
            start adding items and collaborating.
          </StyledEmptyStateText>
        </StyledEmptyState>
      )}
      </StyledBox>
      </>
    )}
     {openProfileSuccess && (
        <ManualSplit
          open={openProfileSuccess}
          handleOpen={handleOpenProfileSuccess}
          handleClose={handleCloseProfileSuccess}
        />
      )}
      {openGroupCartDetails && (
        <CreateGroup
          open={openGroupCartDetails}
          handleOpen={handleOpenGroupCartDetails}
          handleClose={handleCloseGroupCartDetails}
          handleOpenProductDetails={handleOpenProductDetails}
        />
      )}
      {openUnassigned && (
        <UnassignedItems
          open={openUnassigned}
          handleClose={() => setOpenUnassigned(false)}
          cartId={singleCart?.id} // 🔹 passing cartId to modal
        />
      )}
      {openInviteMembers && (
        <InviteMembers
          open={openInviteMembers}
          handleClose={handleCloseInviteMembers}
          cartId={singleCart?.id} // optional, if you want to pass which cart
        />
      )}
      {openGuidelinesDetails && (
        <GroupCartGuidelines
          open={openGuidelinesDetails}
          handleOpen={handleOpenProductDetails}
          handleClose={handleCloseProductDetails}
        />
      )}
    </>
   
  );
};

export default GroupCart;
